import React from 'react';
import { Link } from 'react-router-dom';
import './MainFooter.css'; // make sure to import this

const MainFooter = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="contact-info">
            <button className="contact-btn">
              <Link to="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                <span>✉</span> Contact us
              </Link>
            </button>
            <span className="text">INDIA, Bangalore, Karnataka</span>
          </div>
        </div>

        {/* Footer Links */}
        <div className="footer-links">
          <div className="footer-column">
            <h6>ELEXYT SEO</h6>
            <Link
              to="/"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById("products");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }, 200);
              }}
            >
              MarketPlace
            </Link>

            <Link to="/finance/sip">Financial Calculators</Link>
            <Link to="/contact">Free Demo</Link>
          </div>

          <div className="footer-column">
            <h6>COMPANY</h6>
            <a href="https://elexyt.com/" target="_blank" rel="noopener noreferrer">
              About Us
            </a>

            <Link to="/contact">
              Contact us
            </Link>
          </div>


          <div className="footer-column">
            <h6>FOLLOW US</h6>

            <Link
              to="#"
              className="d-flex align-items-center mb-2"
            >
              <i className="fab fa-x-twitter me-2"></i> X (Twitter)
            </Link>

            <Link
              to="https://www.linkedin.com/company/104980686/admin/page-posts/published/"
              className="d-flex align-items-center mb-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin me-2"></i> LinkedIn
            </Link>

            <Link
              to="https://www.youtube.com/@ElexytTech"
              className="d-flex align-items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube me-2"></i> YouTube
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
